import React, { useState } from "react";
import { Upload, Spin, Typography } from "antd";
import { InboxOutlined, LoadingOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { extractPoFromPdf } from "../../api/poIngestApi";

const { Dragger } = Upload;
const { Text } = Typography;

const PoIngestDropzone = ({ onIngested, customerIdHint, disabled }) => {
  const [loading, setLoading] = useState(false);

  const handleBeforeUpload = async (file) => {
    if (file.type !== "application/pdf") {
      toast.error("Only PDF files are supported");
      return false;
    }
    if (file.size > 10 * 1024 * 1024) {
      toast.error("File must be under 10 MB");
      return false;
    }

    setLoading(true);
    try {
      const result = await extractPoFromPdf(file, customerIdHint);
      // Pass the raw file up too — the caller uses it to attach the same PDF as the order's/
      // quotation's PO document, so the operator doesn't have to upload it a second time into
      // a separate "attach PO document" widget just to keep a copy of what they dropped here.
      onIngested(result, file);
    } catch (err) {
      const msg = err?.response?.data?.message || err.message || "Extraction failed";
      toast.error(`PO extraction failed: ${msg}`);
    } finally {
      setLoading(false);
    }

    // Prevent antd's default upload
    return false;
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <Dragger
        accept=".pdf"
        multiple={false}
        showUploadList={false}
        beforeUpload={handleBeforeUpload}
        disabled={disabled || loading}
        style={{ borderColor: "#4f46e5", background: "#f5f3ff", padding: "8px 0" }}
      >
        {loading ? (
          <div style={{ padding: "16px 0" }}>
            <Spin indicator={<LoadingOutlined style={{ fontSize: 28, color: "#4f46e5" }} spin />} />
            <p style={{ marginTop: 12, color: "#4f46e5", fontWeight: 500 }}>
              Extracting PO data…
            </p>
            <Text type="secondary" style={{ fontSize: 12 }}>
              Reading text, matching items — usually 3–8 seconds
            </Text>
          </div>
        ) : (
          <div style={{ padding: "8px 0" }}>
            <p>
              <InboxOutlined style={{ fontSize: 32, color: "#4f46e5" }} />
            </p>
            <p style={{ fontWeight: 500, color: "#1f2937", margin: "4px 0" }}>
              Drop customer PO PDF here to auto-fill
            </p>
            <Text type="secondary" style={{ fontSize: 12 }}>
              PDF only · max 10 MB · extracts items, quantities &amp; rates automatically
            </Text>
          </div>
        )}
      </Dragger>
    </div>
  );
};

export default PoIngestDropzone;
